module.exports = __webpack_public_path__ + "static/double-e304a82742e047ed48eff3b9142bf07f.jpg";